import {PromotionStep} from '@/types/promotion'
import {
  PromotionAttributesStep,
  PromotionDisplayStep,
  PromotionReviewStep,
  PromotionSetupStep,
} from './steps'

/**
 * Wrapper for promotion step resolver used by the new themed create flow.
 * @param {{
 *  step: import('@/types/promotion').PromotionStep,
 *  promotion: import('@/types/promotion').Promotion,
 *  setCurrentStep: (step: import('@/types/promotion').PromotionStep) => void,
 * }} props
 */
export const PromotionStepContent = ({step, promotion, setCurrentStep}) => {
  switch (step) {
    case PromotionStep.SETUP:
      return <PromotionSetupStep />
    case PromotionStep.DISPLAY:
      return <PromotionDisplayStep />
    case PromotionStep.ATTRIBUTES:
      return <PromotionAttributesStep />
    case PromotionStep.REVIEW:
      return <PromotionReviewStep promotion={promotion} setCurrentStep={setCurrentStep} />
    default:
      return null
  }
}
